import { Text } from '../types/text';
import BaseEntityService from './baseEntityService'

const serviceUrlSuffix = 'v1/texts'

class TextService extends BaseEntityService<Text> {
    constructor() {
        super(serviceUrlSuffix);
    }

    async updateEnableStatus(textId: string, status: boolean): Promise<void> {
        status ? await this.httpClient.put(`/${textId}/disable`) : await this.httpClient.put(`/${textId}/enable`);
    }
}

export const textService = new TextService();

